import React from 'react'
import { Card, CardContent, Grid, CardActionArea, Avatar, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import head from 'img/007.png'
import line from 'img/008.png'
import oa from 'img/009.png'
import web from 'img/010.png'
import facebook from 'img/011.png'
import foa from 'img/012.png'
import youtube from 'img/013.png'
import app from 'img/014.png'
import tiktok from 'img/015.png'
import linescreen from 'img/033.png'
import webscreen from 'img/034.png'
import facescreen from 'img/035.png'
import youscreen from 'img/036.png'
import appscreen from 'img/037.png'
import tkscreen from 'img/038.png'

import Swal from 'sweetalert2';

const Contact = ({setPage}) => {
    return ( 
        <Card style={{backgroundColor: "#19459D"}}>
        <CardContent>
        <div className='d-flex justify-content-center'>
                <img src={head} width='440vw' />
           </div>
            <Card style={{backgroundColor: "#E6E7E8"}}>
                <CardContent>
                   {window.innerWidth > 900 ? (
                     <Grid container>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={line} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                             <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D"}}>Line กบข. GPF Community สังเกตเครื่องหมายโล่สีเขียว</b>
                                     </h5>
                                 }
                                 secondary={
                                     <div className='mt-4' style={{color: "#19459D", fontSize: 16}}>
                                         โปรดสังเกตเครื่องหมายโล่สีเขียว <img src={oa} width='130' />
                                     </div>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                            <img src={linescreen} width='100%' />
                     </Grid>
                     <Grid item xs={12}>
                         <hr className='border border-primary' />
                     </Grid>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={web} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                              <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D", whiteSpace: 'initial'}}>เว็บไซต์ กบข. : https://www.gpf.or.th</b>
                                     </h5>
                                 }
                                 secondary={
                                     <div className='mt-4' style={{color: "#19459D", fontSize: 16}}>
                                         โปรดสังเกตเว็บทางการ กบข.
                                     </div>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                         <img src={webscreen} width='100%' />
                     </Grid>
                     <Grid item xs={12}>
                         <hr className='border border-primary' />
                     </Grid>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={facebook} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                             <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D"}}>Facebook Fanpage : กองทุนบำเหน็จบำนาญข้าราชการ (กบข.)</b>
                                     </h5>
                                 }
                                 secondary={
                                     <div className='mt-4' style={{color: "#19459D", fontSize: 16}}>
                                         โปรดสังเกตเครื่องหมายถูกสีฟ้า <img src={foa} width='130' />
                                     </div>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                         <img src={facescreen} width='100%' />
                     </Grid>
                     <Grid item xs={12}>
                         <hr className='border border-primary' />
                     </Grid>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={youtube} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                              <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D"}}>Youtube กบข. : กองทุนบำเหน็จบำนาญข้าราชการ กบข.</b>
                                     </h5>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                         <img src={youscreen} width='100%' />
                     </Grid>
                     <Grid item xs={12}>
                         <hr className='border border-primary' />
                     </Grid>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={app} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                              <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D"}}>แอป กบข. : My GPF Application</b>
                                     </h5>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                         <img src={appscreen} width='100%' />
                     </Grid>
                     <Grid item xs={12}>
                         <hr className='border border-primary' />
                     </Grid>
                     <Grid item md={6} xs={12} className="d-flex align-items-center">
                         <ListItem>
                             <ListItemAvatar>
                                 <Avatar src={tiktok} sx={{ width: 130, height: 130 }} />
                             </ListItemAvatar>
                              <ListItemText
                                 primary={
                                     <h5>
                                         <b style={{color: "#19459D"}}>TikTok กบข. : @gpf_community</b>
                                     </h5>
                                 }
                             />
                         </ListItem>
                     </Grid>
                     <Grid item md={6} xs={12}>
                         <img src={tkscreen} width='100%' />
                     </Grid>
                 </Grid>
                   ) : (
                    <Grid container>
                    <Grid item md={6} xs={12}>
                        <Grid container>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                                <img src={line} style={{ width: 130, height: 130 }} />
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                                <h5>
                                    <b style={{color: "#19459D"}}>Line กบข. GPF Community สังเกตเครื่องหมายโล่สีเขียว</b>
                                </h5>
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center' style={{color: "#19459D", fontSize: 16}}>
                                โปรดสังเกตเครื่องหมายโล่สีเขียว
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center' style={{color: "#19459D", fontSize: 16}}>
                                <img src={oa} width='80' />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                            <img src={linescreen} width='100%' />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className='border border-primary' />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid container>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                                <img src={web} style={{ width: 130, height: 130 }} />
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                                <h5>
                                    <b style={{color: "#19459D"}}>เว็บไซต์ กบข. : https://www.gpf.or.th</b>
                                </h5>
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center' style={{color: "#19459D", fontSize: 16}}>
                                โปรดสังเกตเว็บทางการ กบข.
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <img src={webscreen} width='100%' />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className='border border-primary' />
                    </Grid>
                    <Grid item md={6} xs={12}>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                                <img src={facebook} style={{ width: 130, height: 130 }} />
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                                <h5>
                                    <b style={{color: "#19459D"}}>Facebook Fanpage : กองทุนบำเหน็จบำนาญข้าราชการ (กบข.)</b>
                                </h5>
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center' style={{color: "#19459D", fontSize: 16}}>
                                โปรดสังเกตเครื่องหมายถูกสีฟ้า
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center' style={{color: "#19459D", fontSize: 16}}>
                                <img src={foa} width='80' />
                            </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <img src={facescreen} width='100%' />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className='border border-primary' />
                    </Grid>
                    <Grid item md={6} xs={12}>
                            <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                                <img src={youtube} style={{ width: 130, height: 130 }} />
                            </Grid>
                            <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                                <h5>
                                    <b style={{color: "#19459D"}}>Youtube กบข. : กองทุนบำเหน็จบำนาญข้าราชการ กบข.</b>
                                </h5>
                            </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <img src={youscreen} width='100%' />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className='border border-primary' />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                            <img src={app} style={{ width: 130, height: 130 }} />
                        </Grid>
                        <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                            <h5>
                                <b style={{color: "#19459D"}}>แอป กบข. : My GPF Application</b>
                            </h5>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <img src={appscreen} width='100%' />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className='border border-primary' />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid item xs={12} className='col-12 d-flex justify-content-center'>
                            <img src={tiktok} style={{ width: 130, height: 130 }} />
                        </Grid>
                        <Grid item xs={12} className='col-12 d-flex text-center justify-content-center'>
                            <h5>
                            <b style={{color: "#19459D"}}>TikTok กบข. : @gpf_community</b>
                            </h5>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <img src={tkscreen} width='100%' />
                    </Grid>
                </Grid>
                   )}
                </CardContent>
            </Card>
        </CardContent>
    </Card>
     );
}
 
export default Contact;